import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { Signal, SignalLow, SignalZero } from 'lucide-react';
import { cn } from '@/lib/utils';

interface NetworkQualityIndicatorProps {
  warnings: string[];
}

export function NetworkQualityIndicator({ warnings }: NetworkQualityIndicatorProps) {
  if (warnings.length === 0) return null;

  const severity = warnings.length >= 3 ? 'critical' : warnings.length >= 1 ? 'warning' : 'good';
  const Icon = severity === 'critical' ? SignalZero : severity === 'warning' ? SignalLow : Signal;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Icon className={cn(
          'h-4 w-4',
          severity === 'critical' && 'text-red-500',
          severity === 'warning' && 'text-yellow-500',
        )} />
      </TooltipTrigger>
      <TooltipContent>
        <p className="text-xs">Network issues: {warnings.join(', ')}</p>
      </TooltipContent>
    </Tooltip>
  );
}
